<template>
  <div class="userStatistic">
    <pageTitle />
    <div class="page-main">
      <div class="numTip-wrap">
        <p class="numTip">
          <span class="numTip-value"  v-text="_totalAccountNum" />
          <span class="numTip-name">总用户量</span>
        </p>
        <p class="numTip">
          <span class="numTip-value" v-text="_curMonthAddedAccount" />
          <span class="numTip-name">本月新增</span>
        </p>


      </div>
      <mLine class="h300" :option="Option" />
    </div>
    <a-row :gutter="20" >
      <a-col class="page-bg" :span="12">
        <div class="page-main">
          <m-pie :data="pie" :option="pieOption" class="h300" />
          <a-table rowKey="index" :pagination="false" bordered :rowClassName="rowClassName" :dataSource="pie" :columns="columns" />
        </div>

      </a-col>
      <a-col class="page-bg" :span="12">
        <div class="page-main">
          <m-pie :data="pie1" :option="pieOption1" class="h300" />
          <a-table rowKey="index" :pagination="false" :rowClassName="rowClassName" bordered :dataSource="pie1" :columns="columns1" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import mPie from "@/components/business/echartsComponents/mPie";
import mLine from "@/components/business/echartsComponents/mLine";

export default {
  name: "userStatistic",
  components: {
    pageTitle,
    mPie,
    mLine
  },
  data() {
    return {
      pie: [],
      pie1: [],
      allData: {},
      Option: {
        grid: {
          left: "3%",
          right: "4%",
          top: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            color: "#999"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#999"
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: "line",
            data: []
          }
        ]
      },
      pieOption: {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}人"
        },
        title: {
          text: "用户所在国家排名",
          left: "left"
        }
      },
      pieOption1: {
        title: {
          text: "用户所在行业排名",
          left: "left"
        }
      },
      columns: [
        {
          title: "排行",
          dataIndex: "index",
          key: "index",
          align: "center"
        },
        {
          title: "国家",
          dataIndex: "name",
          key: "name",
          align: "center"
        },
        {
          title: "数量",
          dataIndex: "value",
          key: "value",
          align: "center"
        }
      ],
      columns1: [
        {
          title: "排行",
          dataIndex: "index",
          key: "index",
          align: "center"
        },
        {
          title: "行业名称",
          dataIndex: "name",
          key: "name",
          align: "center"
        },
        {
          title: "用户量",
          dataIndex: "value",
          key: "value",
          align: "center"
        }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData: async function() {
      const res = await this.$get("bluetoothlight/web/statistics/account");

      const resultStatus = res?.resultStatus;
      if (!resultStatus) return false;
      const data = res?.resultData;
      this.allData = data;

      const accountPeriodStatistics = data?.accountPeriodStatistics;
      if (this.verifyData(accountPeriodStatistics)) {

        const { Option } = this;
        const { xAxis } = Option;
        this.Option = {
          ...Option,

          xAxis: {
            ...xAxis,
            data: accountPeriodStatistics.map(el => el?.totalDate)
          },
          series: [
            {
              name: "近30天新增",
              type: "line",
              emphasis: {
                focus: "series"
              },
              areaStyle: {

                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, .9, [{
                  offset: 0,
                  color: "#0082FF"
                }, {
                  offset: 0.3,
                  color: "#0082FF"
                },
                  {
                    offset: 0.5,
                    color: "#0082FF"
                  }, {
                    offset: 1,
                    color: "#F9FCFF"
                  }])
              },
              smooth: true,
              symbol: "none",
              data: accountPeriodStatistics?.map(el => el?.accountNum) || []
            }
          ]
        };
      }
      const countryStatisticsTopN = data?.countryStatisticsTopN;
      if (this.verifyData(countryStatisticsTopN)) {
        this.pie = countryStatisticsTopN.map(({ country, accountNum }, index) => ({
          index: index + 1,
          value: accountNum,
          name: country
        }));
      }
      const jobStatisticsTopN = data?.jobStatisticsTopN;
      if (this.verifyData(jobStatisticsTopN)) {
        this.pie1 = jobStatisticsTopN.map(({ jobId, jobName,accountNum }, index) => ({
          index: index + 1,
          value: accountNum,
          name: jobName
        }));
      }
    },
    verifyData(data) {
      return data && data.length;
    },
    rowClassName(record, index) {
      let className = "";
      if (index % 2 === 1) className = "tableBg";
      return className;
    }

  },
  computed: {
    _totalAccountNum() {
      return this?.allData?.summaryStatistics?.totalAccountNum || 0;
    },
    _curMonthAddedAccount() {
      return this?.allData?.summaryStatistics?.curMonthAddedAccount || 0;
    }
  }
};
</script>

<style lang="less">
.tableBg {
  background-color: rgba(0, 0, 0, .06);
}

.h300 {
  height: 300px !important;
}
.numTip-value {
  color: #0082ff;
}
</style>
